import { render } from "./CompleteTable.vue?vue&type=template&id=594bff18&scoped=true&ts=true"
import script from "./CompleteTable.ts?vue&type=script&lang=ts"
export * from "./CompleteTable.ts?vue&type=script&lang=ts"

import "./CompleteTable.scss?vue&type=style&index=0&id=594bff18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594bff18"]])

export default __exports__